export const SET_APP_VERSION = 'feature-toggle/SET_APP_VERSION'
export const FETCH_FEATURES = 'feature-toggle/FETCH_FEATURES'
